import styled from '@emotion/styled'

export const BaseTileStyled = styled.div`
  width: 100%;
  height: 100%;
`
